import { LenderUserQuery } from '../../../types/lenderTypes'
import { MulticallRetryFunction } from '../../../types'
import { MULTICALL_DEFAULT_BATCH_SIZE } from '../../../utils/constants'
import type { LenderToLenderCrossPoolMeta } from '../utils/types'
import { prepareMergedMulticallParams } from './prepare'
import { parseMergedResult } from './parse'
import type {
  PermissionParams,
  TokenApprovalParams,
  MergedUserData,
} from './types'

/**
 * Fetches merged token approval + permission + balance data
 * in a single multicallRetry call.
 */
export async function getMergedUserData(
  chainId: string,
  balanceQueries: LenderUserQuery[],
  permissionParams: PermissionParams,
  lenderState: LenderToLenderCrossPoolMeta,
  multicallRetry: MulticallRetryFunction,
  batchSize = MULTICALL_DEFAULT_BATCH_SIZE,
  maxRetries = 3,
  tokenApprovalParams?: TokenApprovalParams,
): Promise<MergedUserData> {
  const prepared = await prepareMergedMulticallParams(
    chainId,
    balanceQueries,
    permissionParams,
    tokenApprovalParams,
  )

  const rawResults = await multicallRetry({
    chain: chainId,
    calls: prepared.calls,
    abi: prepared.abis,
    batchSize,
    maxRetries,
  })
  return parseMergedResult(chainId, rawResults, prepared, lenderState)
}
